export const Twitter = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.2793 10.6291C36.0016 11.1971 34.6264 11.5802 33.1836 11.7517C34.6568 10.8697 35.7864 9.47274 36.3191 7.80622C34.9411 8.62396 33.4157 9.21733 31.7908 9.53765C30.4905 8.15194 28.637 7.28552 26.586 7.28552C22.6483 7.28552 19.4556 10.4782 19.4556 14.4166C19.4556 14.9747 19.5184 15.5186 19.6405 16.0415C13.7138 15.7437 8.45885 12.9053 4.94166 8.5908C4.32783 9.64348 3.97646 10.8683 3.97646 12.1764C3.97646 14.6501 5.23517 16.8331 7.14863 18.1115C5.98023 18.0742 4.88027 17.7531 3.9186 17.219C3.9179 17.2487 3.9179 17.279 3.9179 17.3093C3.9179 20.7637 6.37605 23.6452 9.63853 24.3014C9.04022 24.4637 8.41016 24.5511 7.75964 24.5511C7.29962 24.5511 6.853 24.5067 6.41768 24.4227C7.32573 27.2555 9.95886 29.3179 13.0788 29.375C10.6383 31.2878 7.5642 32.428 4.2227 32.428C3.64767 32.428 3.0797 32.3941 2.52161 32.3278C5.67826 34.352 9.42616 35.5317 13.4528 35.5317C26.5697 35.5317 33.7417 24.6662 33.7417 15.2428C33.7417 14.9337 33.7353 14.6254 33.7219 14.3192C35.1147 13.3159 36.324 12.0593 37.2793 10.6291Z"
        fill="hsl(var(--fc1), 50%)"
      />
    </svg>
  );
};
